import { useOutletContext } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Overview as OverviewComponent } from 'modules/trainings/components/Revamp/TrainingsDetail/Overview'
import { OverviewEmptyState } from 'modules/trainings/components/Revamp/TrainingsDetail/Overview/EmptyState'
import { DetailOutletContext } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

export default function Overview() {
  const { training, competencies } = useOutletContext<DetailOutletContext>()

  const emptyTraining =
    training &&
    !training?.description.length &&
    !training?.objectives &&
    !training?.competencyIds?.length &&
    !training?.categories?.length &&
    !training?.code?.length &&
    !training?.validFor &&
    !training?.fundaeSubsidized &&
    parseFloat(training.totalTrainingCost) <= 0 &&
    parseFloat(training.totalTrainingIndirectCost) <= 0 &&
    parseFloat(training.totalTrainingSalaryCost) <= 0 &&
    parseFloat(training.totalTrainingSubsidizedCost) <= 0 &&
    !training?.externalProvider?.length

  if (emptyTraining || !training) return <OverviewEmptyState trainingId={Number(training?.id)} />
  return (
    <ResponsivePage.Body showHeader={false} variant="fullscreen">
      <OverviewComponent training={training} competencies={competencies || []} />
    </ResponsivePage.Body>
  )
}
